/* =============================================================================
   PDP gallery enhancer — layers onto the existing [data-ph-slider]:
     • a thumbnail strip (mobile: replaces the dots; drag + follows the active slide)
     • mobile: tap the image to zoom 2× at the tapped point, drag to pan, ✕ to close
     • desktop: click the image to open a modal (large image + thumbnails + arrows,
       with click-to-zoom + drag-pan inside)
   It DRIVES the slider through its existing dot buttons, so the slider's own
   paging/swipe logic is left untouched. Dependency-free.
   ============================================================================= */
(function () {
  "use strict";

  var mqMobile = window.matchMedia("(max-width: 749px)");

  function sizedSrc(src, w) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, "$1" + w);
    if (/cdn\.shopify\.com/.test(src)) return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
    return src;
  }
  function baseSrc(img) {
    return img.getAttribute("src") || img.currentSrc || img.src || "";
  }
  function clamp(v, min, max) { return v < min ? min : v > max ? max : v; }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    document.querySelectorAll("[data-ph-slider]").forEach(init);
  });

  function init(slider) {
    if (slider.getAttribute("data-ph-enhanced")) return;
    slider.setAttribute("data-ph-enhanced", "1");

    var track = slider.querySelector("[data-ph-track]");
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var imgs = slides.map(function (s) { return s.querySelector("img"); }).filter(Boolean);
    if (imgs.length < 1) return;
    var srcs = imgs.map(baseSrc);
    var dotsWrap = slider.querySelector("[data-ph-dots]");
    var gallery = slider.closest(".ph__gallery") || slider.parentNode;

    function currentIndex() {
      if (dotsWrap) {
        var ds = dotsWrap.children;
        for (var i = 0; i < ds.length; i++) if (ds[i].classList.contains("is-on")) return i;
      }
      return 0;
    }
    // Drive the existing slider by clicking its dot for slide n (keeps its logic).
    function goTo(n) {
      var len = imgs.length;
      n = ((n % len) + len) % len;
      if (dotsWrap && dotsWrap.children[n]) dotsWrap.children[n].click();
      else track.style.transform = "translateX(-" + (n * 100) + "%)";
      return n;
    }

    /* ---- thumbnail strip -------------------------------------------------- */
    var strip = document.createElement("div");
    strip.className = "ph-gal__thumbs";
    var thumbBtns = srcs.map(function (src, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ph-gal__thumb";
      b.setAttribute("aria-label", "Show image " + (i + 1));
      var t = document.createElement("img");
      t.src = sizedSrc(src, 200); t.alt = ""; t.loading = "lazy"; t.decoding = "async";
      b.appendChild(t);
      b.addEventListener("click", function () { goTo(i); });
      strip.appendChild(b);
      return b;
    });
    gallery.insertBefore(strip, slider.nextSibling);

    function centerThumb(i) {
      var b = thumbBtns[i];
      if (!b || strip.scrollWidth <= strip.clientWidth + 4) return;
      var br = b.getBoundingClientRect(), sr = strip.getBoundingClientRect();
      strip.scrollTo({ left: strip.scrollLeft + (br.left - sr.left) - (sr.width - br.width) / 2, behavior: "smooth" });
    }
    function syncActive() {
      var n = currentIndex();
      for (var i = 0; i < thumbBtns.length; i++) thumbBtns[i].classList.toggle("is-on", i === n);
      centerThumb(n);
      if (zoom) zoom.reset();   // navigating (arrow/dot/swipe) returns the image to normal
    }
    if (dotsWrap) {
      new MutationObserver(syncActive).observe(dotsWrap, { subtree: true, attributes: true, attributeFilter: ["class"] });
    }
    syncActive();

    /* ---- interaction: mobile zoom-in-place / desktop modal ---------------- */
    var zoom = setupMobileZoom(slider, imgs, currentIndex);
    var modal = buildModal(srcs, goTo);
    // Tap/click on the image: mobile zooms in place, desktop opens the modal.
    slider.addEventListener("click", function (e) {
      if (e.target.closest("[data-ph-prev],[data-ph-next],[data-ph-dots],.ph-gal__zclose")) return;
      if (mqMobile.matches) return;           // mobile handled by touch (zoom-in-place)
      modal.open(currentIndex());
    });
  }

  /* ========================================================================
     Mobile: tap to zoom 2× at the point, drag to pan (edge-clamped), ✕ closes.
     While zoomed, the slider's swipe is suppressed (capture + stopPropagation).
     ======================================================================== */
  function setupMobileZoom(slider, imgs, currentIndex) {
    var scale = 1, tx = 0, ty = 0, w = 0, h = 0, active = null, zoomed = false;
    var startX = 0, startY = 0, baseTx = 0, baseTy = 0, moved = false, panning = false;

    function apply() {
      if (active) active.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
    }
    function clampPan() {
      var mx = (scale - 1) * w / 2, my = (scale - 1) * h / 2;
      tx = clamp(tx, -mx, mx); ty = clamp(ty, -my, my);
    }
    function reset() {
      if (active) { active.style.transition = "transform .2s ease"; active.style.transform = ""; }
      zoomed = false; scale = 1; tx = ty = 0; active = null;
      slider.classList.remove("is-zoomed");
    }
    function zoomAt(clientX, clientY) {
      active = imgs[currentIndex()];
      if (!active) return;
      var r = active.getBoundingClientRect();
      w = r.width; h = r.height;
      scale = 2;
      tx = -scale * (clientX - r.left - w / 2);
      ty = -scale * (clientY - r.top - h / 2);
      clampPan();
      active.style.transformOrigin = "center center";
      active.style.transition = "transform .2s ease";
      apply();
      zoomed = true;
      slider.classList.add("is-zoomed");
    }

    slider.addEventListener("touchstart", function (e) {
      if (!mqMobile.matches) return;
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; moved = false;
      if (zoomed) { baseTx = tx; baseTy = ty; panning = true; if (active) active.style.transition = "none"; }
    }, { passive: true, capture: true });

    slider.addEventListener("touchmove", function (e) {
      if (!mqMobile.matches) return;
      var t = e.touches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
      if (zoomed && panning) {
        // Take over the gesture: pan and stop the slider's swipe from firing.
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
        tx = baseTx + dx; ty = baseTy + dy; clampPan(); apply();
      }
    }, { passive: false, capture: true });

    slider.addEventListener("touchend", function (e) {
      if (!mqMobile.matches) return;
      panning = false;
      // Taps on the arrows/dots/close are navigation, not a zoom request.
      if (e.target.closest("[data-ph-prev],[data-ph-next],.ph-gal__arrow,[data-ph-dots],.ph-gal__dot,.ph-gal__zclose")) return;
      if (!moved) {
        // A tap toggles: zoom in at the point, or tap again to return to normal.
        if (zoomed) reset();
        else zoomAt(startX, startY);
      }
    }, { passive: true, capture: true });

    return { reset: reset };
  }

  /* ========================================================================
     Desktop modal: large image + thumbnail strip + arrows, click-to-zoom + pan.
     One modal is shared; opened with a slide index, synced back to the page on close.
     ======================================================================== */
  function buildModal(srcs, goTo) {
    var el = document.createElement("div");
    el.className = "phz";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<div class="phz__backdrop" data-phz-close></div>' +
      '<div class="phz__dialog" role="dialog" aria-modal="true" aria-label="Product images">' +
        '<button class="phz__x" type="button" data-phz-close aria-label="Close"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="phz__frame">' +
          '<button class="phz__nav phz__prev" type="button" data-phz-prev aria-label="Previous"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="phz__stage" data-phz-stage><img class="phz__img" data-phz-img alt=""></div>' +
          '<button class="phz__nav phz__next" type="button" data-phz-next aria-label="Next"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '</div>' +
        '<div class="phz__thumbs" data-phz-thumbs></div>' +
      '</div>';
    document.body.appendChild(el);

    var stage = el.querySelector("[data-phz-stage]");
    var img = el.querySelector("[data-phz-img]");
    var thumbsWrap = el.querySelector("[data-phz-thumbs]");
    var idx = 0, savedScrollY = 0;
    var zoomState = { on: false, scale: 1, tx: 0, ty: 0, w: 0, h: 0 };

    var thumbBtns = srcs.map(function (src, i) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "phz__thumb"; b.setAttribute("aria-label", "Image " + (i + 1));
      var t = document.createElement("img"); t.src = sizedSrc(src, 200); t.alt = ""; t.loading = "lazy";
      b.appendChild(t);
      b.addEventListener("click", function () { show(i); });
      thumbsWrap.appendChild(b);
      return b;
    });

    function resetZoom() {
      zoomState.on = false; zoomState.scale = 1; zoomState.tx = 0; zoomState.ty = 0;
      img.style.transform = ""; stage.classList.remove("is-zoomed");
    }
    function show(i) {
      idx = ((i % srcs.length) + srcs.length) % srcs.length;
      resetZoom();
      img.src = sizedSrc(srcs[idx], 2048);
      for (var k = 0; k < thumbBtns.length; k++) thumbBtns[k].classList.toggle("is-on", k === idx);
      var b = thumbBtns[idx];
      if (b && thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 4) {
        var br = b.getBoundingClientRect(), sr = thumbsWrap.getBoundingClientRect();
        thumbsWrap.scrollTo({ left: thumbsWrap.scrollLeft + (br.left - sr.left) - (sr.width - br.width) / 2, behavior: "smooth" });
      }
    }
    function open(i) {
      show(i);
      savedScrollY = window.scrollY || 0;
      document.body.style.position = "fixed"; document.body.style.top = -savedScrollY + "px";
      document.body.style.left = "0"; document.body.style.right = "0"; document.body.style.width = "100%";
      el.classList.add("is-open"); el.setAttribute("aria-hidden", "false");
      var x = el.querySelector(".phz__x"); if (x) x.focus({ preventScroll: true });
    }
    function close() {
      el.classList.remove("is-open"); el.setAttribute("aria-hidden", "true");
      document.body.style.position = ""; document.body.style.top = "";
      document.body.style.left = ""; document.body.style.right = ""; document.body.style.width = "";
      window.scrollTo(0, savedScrollY);
      resetZoom();
      goTo(idx);   // keep the in-page slider in sync with where they ended up
    }

    // click-to-zoom + drag-pan inside the modal (mouse)
    function zoomAt(clientX, clientY) {
      var r = img.getBoundingClientRect();
      zoomState.w = r.width; zoomState.h = r.height; zoomState.scale = 2;
      zoomState.tx = clamp(-2 * (clientX - r.left - r.width / 2), -r.width / 2, r.width / 2);
      zoomState.ty = clamp(-2 * (clientY - r.top - r.height / 2), -r.height / 2, r.height / 2);
      zoomState.on = true;
      stage.classList.add("is-zoomed");
      img.style.transformOrigin = "center center";
      img.style.transform = "translate(" + zoomState.tx + "px," + zoomState.ty + "px) scale(2)";
    }
    var dragging = false, dsx = 0, dsy = 0, btx = 0, bty = 0, movedM = false;
    img.addEventListener("mousedown", function (e) {
      if (!zoomState.on) return;
      dragging = true; movedM = false; dsx = e.clientX; dsy = e.clientY; btx = zoomState.tx; bty = zoomState.ty;
      e.preventDefault();
    });
    window.addEventListener("mousemove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - dsx, dy = e.clientY - dsy;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) movedM = true;
      var mx = (zoomState.scale - 1) * zoomState.w / 2, my = (zoomState.scale - 1) * zoomState.h / 2;
      zoomState.tx = clamp(btx + dx, -mx, mx); zoomState.ty = clamp(bty + dy, -my, my);
      img.style.transform = "translate(" + zoomState.tx + "px," + zoomState.ty + "px) scale(" + zoomState.scale + ")";
    });
    window.addEventListener("mouseup", function () { dragging = false; });
    img.addEventListener("click", function (e) {
      if (movedM) { movedM = false; return; }
      if (zoomState.on) resetZoom(); else zoomAt(e.clientX, e.clientY);
    });

    el.addEventListener("click", function (e) { if (e.target.closest("[data-phz-close]")) close(); });
    el.querySelector("[data-phz-prev]").addEventListener("click", function () { show(idx - 1); });
    el.querySelector("[data-phz-next]").addEventListener("click", function () { show(idx + 1); });
    document.addEventListener("keydown", function (e) {
      if (!el.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") show(idx - 1);
      else if (e.key === "ArrowRight") show(idx + 1);
    });

    return { open: open };
  }
})();
